import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, FormControlLabel, Checkbox, Grid } from "@material-ui/core";
import SelectAllControls from "../SelectAllControls";
import VehicleService from "services/VehicleService";
import useDealerId from "hooks/useDealerId";

export default function CategorySelection({
    selectedCategories = [],
    setSelectedCategories = () => {},
}) {
    const [allCategories, setAllCategories] = useState([]);

    const dealerId = useDealerId();

    useEffect(() => {
        const fetchCategories = async () => {
            const categories = await VehicleService.getCategories({
                dlid: dealerId,
                makeId: "all",
                yearId: "all",
                modelId: "all",
                trimId: "all",
                engineId: "all",
                catalog: "isuzu_fv",
            });

            const filteredCategories = categories.filter((c) => c.category_name !== "Accessories");

            setAllCategories(filteredCategories);
        };

        if (dealerId) {
            fetchCategories();
        }
    }, [dealerId]);

    const handleToggle = (id) => {
        setSelectedCategories(
            selectedCategories.includes(id)
                ? selectedCategories.filter((item) => item !== id)
                : [...selectedCategories, id],
        );
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Select Categories
                </Typography>
                <SelectAllControls
                    setSelectedItems={setSelectedCategories}
                    items={allCategories}
                    disabled={false}
                />
                <Grid container spacing={2}>
                    {allCategories.map((category) => (
                        <Grid
                            item
                            xs={12}
                            key={category.id}
                            style={{ paddingTop: 0, paddingBottom: 0 }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedCategories.includes(category.id)}
                                        onChange={() => handleToggle(category.id)}
                                        color="primary"
                                    />
                                }
                                label={category.category_name}
                            />
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
}
